import { AnfrageDisplayModel, GlobalEnumerationsAceTypphase } from "@/api/model-index";
import { AnfrageService } from "@/api/services/anfrage.service";
import { AnfrageContract } from "@/core/models/abstractions/anfrage.contract";
import { I18nService } from "@/core/services/i18nService";
import { PortalContextService } from "@/core/services/portal-context.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { NotificationService } from "@progress/kendo-angular-notification";

@Injectable({
    providedIn: 'root'
})
export class ReportsGuard  {
    protected instance: AnfrageContract | null;
  
    constructor(protected readonly portalContextService: PortalContextService, protected readonly anfrageService: AnfrageService, protected notificationService: NotificationService, protected langService: I18nService)
    {
        //
    }

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
        let anfrage = this.portalContextService.CurrentAnfrage;
        if (!this.portalContextService.CurrentAnfrage) {
            anfrage = await this.getAnfrage(route, state);
        }

        if (anfrage?.phase?.typ == GlobalEnumerationsAceTypphase.Bericht || anfrage?.phase?.typ == GlobalEnumerationsAceTypphase.Abschluss)
        {
            let url: string = state.url;
            let urlParts: string[] = url.split("/");

            if (urlParts[2] == "reports") {
                return Promise.resolve(true);
            }
        }
        this.notificationService.show({
            hideAfter: 5000,
            content: this.langService.instant("anfrage.reports-guard.error"),
            animation: { type: "fade", duration: 500 },
            position: { horizontal: "center", vertical: "bottom" },
            type: { style: "error", icon: true },
        });
        return Promise.resolve(false);
    }

    getAnfrage(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<AnfrageDisplayModel> { 
        return this.anfrageService.apiAnfrageAnfrageIdGet({ anfrageId: this.portalContextService.CurrentItemContext.id }).toPromise();
    }
}